/* import __COLOCATED_TEMPLATE__ from './intercom-workspace-warning.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();